import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { DocumentsService } from "../service/Documents.Service";
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
import { UserData } from "../../model/index";
import { FileToUpload } from "../../Model/Documents/FileToUpload";

declare var require: any;
@Component({
    selector: 'MentisSoft-Documents',
    template: require('../Template/Documents.template.html'),
    styles: [require('../Template/Documents.css')],
    providers: [DocumentsService]
})

export class DocumentsComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    loading = false;
    fileList = [];
    // Maximum file size allowed to be uploaded = 5MB
    MAX_SIZE: number = 5048576;
    theFile: any = null;
    messages: string[] = [];
    message: string = "";
    errormessage: string = "";
  
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private uploadService: DocumentsService,
        private router: Router) {
       this.loading=true;
    }
    
    ngAfterViewInit(): void {  
          $('#overlay').hide();
    }
    ngOnInit() {
    this.loading=false;
    }
    public getFileDetails(e) {
        this.fileList = [];
        this.theFile = null;
        this.message = "";
        this.errormessage = "";
        if (e.target.files && e.target.files.length > 0) {
            for (var i = 0; i < e.target.files.length; i++) {
                this.fileList.push(e.target.files[i]);
                // Don't allow file sizes over 1MB
                if (e.target.files[0].size < this.MAX_SIZE) {
                    // Set theFile property
                    this.theFile = e.target.files[i];
                    this.message = "";
                    this.errormessage = "";
                }
                else {
                    this.message = "";
                    this.errormessage = "File: " + e.target.files[0].name + " is too large to upload.";
                }
            }
        }
    }
    public removeSelectedFile(index) {
        this.message = "";
        this.errormessage = "";
        this.fileList.splice(index, 1);
        this.theFile = null;
    }


    public Upload() {
        if (this.theFile != null) {
            this.readAndUploadFile(this.theFile);
        } else {
            this.message = "";
            this.errormessage = "Please Select File."
        }
    }
    private readAndUploadFile(theFile: any) {
        let file = new FileToUpload();
        file.PatientId = this._SecurityService.pid;
        file.fileName = theFile.name;
        file.fileSize = theFile.size;
        file.fileType = theFile.type;
        file.lastModifiedTime = theFile.lastModified;
        file.lastModifiedDate = theFile.lastModifiedDate;
        file.FolderType = "DOCS";
        let reader = new FileReader();

        reader.onload = () => {
            // Store base64 encoded representation of file
            file.fileAsBase64 = reader.result.toString().split(',')[1].toString();
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            this.uploadService.FilesToUpload(file, userData).subscribe(
                p => {
                    if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                        if (p.Status == "SUCCESS") {
                            this.message = "File Uploaded Successfully."
                            this.errormessage = "";
                        } else {
                            this.message = "";
                            this.errormessage = "File Upload Failed!"
                        }
                    }
                    else if (!p.sessionExpiry) {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                }, err => {
                    this.message = "";
                    this.errormessage = "File Upload Failed!"
                    console.log("Error while getting data...");
                });
        }
        reader.readAsDataURL(theFile);
    }
    private handleError(error: any) {
        console.log("error : " + error);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Documents/Component/Documents.Component.ts